import React from "react";

import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { IMeasureGroupChild, IMeasureGroupOneInvestor, IRecommendationChild, IRecommendationItem } from "store/types";

import { GroupedRow } from "./components/Rows/GroupedRow";
import { MeasureGroupRow } from "./components/Rows/MeasureGroupRow";
import { ParameterRow } from "./components/Rows/ParameterRow";
import { useAiDataContext } from "./context/AiData-context";

interface Props {
  row: IRecommendationChild[];
  dealId: number;
  fileId: number;
}

export const ParameterTable: React.FC<Props> = ({ row, dealId, fileId }) => {
  const { generateUniqueId } = useAiDataContext();

  return (
    <TableRow>
      <TableCell colSpan={10} sx={{ padding: "10px 28px 10px 28px !important" }}>
        <Box sx={{ backgroundColor: "#F8FBFF" }}>
          <TableContainer
            sx={{
              borderRadius: "10px",
              border: "1px solid #DBE8F5",
              background: "white",
              "& .MuiTable-root": {
                borderCollapse: "separate",
                borderSpacing: 0
              },
              "& .MuiTableHead-root .MuiTableCell-root": {
                backgroundColor: "#F7FAFD",
                borderBottom: "1px solid #DBE8F5"
              },
              "& .MuiTableBody-root .MuiTableCell-root": {
                borderBottom: "1px solid #DBE8F5"
              },
              "& .MuiTableCell-root": {
                padding: "6px 16px"
              }
            }}
          >
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1, minWidth: "200px" }}
                  >
                    Parameter
                  </TableCell>
                  {/* <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Round
                  </TableCell> */}
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Investor
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Value
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Effective Date
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Reference
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Classification
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#F7FAFD", position: "sticky", top: 0, zIndex: 1 }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row.map((parameter: IRecommendationChild) => (
                  <React.Fragment key={generateUniqueId(parameter, fileId)}>
                    {/* // render measure group has different investors and date */}
                    {Boolean(parameter?.children?.length && !("investor" in parameter)) && (
                      <MeasureGroupRow parameter={parameter as IMeasureGroupChild} dealId={dealId} fileId={fileId} />
                    )}
                    {/* //render simple parameter row if it has no children */}
                    {!parameter?.children?.length && (
                      <ParameterRow
                        parameter={parameter as IRecommendationItem}
                        dealId={dealId}
                        fileId={fileId}
                        nestedLevel="noGroup"
                      />
                    )}
                    {/* //render grouped row if one investor and children */}
                    {Boolean(parameter?.children?.length && "investor" in parameter) && (
                      <GroupedRow parameter={parameter as IMeasureGroupOneInvestor} dealId={dealId} fileId={fileId} />
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </TableCell>
    </TableRow>
  );
};
